import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibWarningOutlineIconV2Component } from './lib-warning-outline-icon-v2.component';

@NgModule({
  declarations: [LibWarningOutlineIconV2Component],
  imports: [CommonModule],
  exports: [LibWarningOutlineIconV2Component],
})
export class LibWarningOutlineIconV2Module {}
